(function sf($) {
    const $sfModal = $('#sf-modal');
    const $iframe  = $sfModal.find('iframe');
    const $try     = $('.isi.tray');
    const $widget  = $('.sf-widget');
    /**
     * Adjust the widget to be 10px above the trey at all times.
     */
    function adjustWidgetPosition(e) {
        if (e && e.type === 'isi-try-hidden') {
            $widget.css('--bottom', '1rem');
            $widget.css('--right', '5rem');
            return;
        }
        const trayHeight = $try.outerHeight();
        const widgetBottom = trayHeight + 20;
        $widget.css('--bottom', `${widgetBottom}px`);
        $widget.css('--right', '1rem');
    }

    // adjust widget on window resize
    $(window).on('resize isi-try-hidden isi-try-shown', adjustWidgetPosition);

    $sfModal.on('show.bs.modal', () => {
        document.body.classList.add('sf-modal-open');

        const currentSrc = $iframe.attr('src');

        if (!currentSrc) {
            const dataSrc = $iframe.attr('data-src');
            $iframe.attr('src', dataSrc);
        }
    });

    $sfModal.on('hidden.bs.modal', () => {
        document.body.classList.remove('sf-modal-open');
        const currentSrc = $iframe.data('src');
        // clear the iframe src
        $iframe.attr('src', '');
        // Exit if its already been updated
        if (currentSrc.includes('intro=0')) return;

        const symbol = currentSrc.includes('?') ? '&' : '?';
        $iframe.attr('data-src', `${currentSrc + symbol}intro=0`);
    });


    // close modal when the Esc key is pressed
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !$sfModal.hasClass('show'))
            $sfModal.modal('hide');
    });

    const init = () => {
        adjustWidgetPosition();
    };

    $(init);
}(jQuery));
